<div class="toastController">
  <p-toast (onClose)="onClose()" showTransitionOptions="300ms ease-out" hideTransitionOptions="200ms ease-in">
    <ng-template #headless let-message let-closeFn="closeFn">
      <div class="p-toast-message-content">
        <sdps-notification type="error" id="sdpsErrorNotification" class="sdps-m-top_none" class="toast-confirmation" *ngIf="message.severity === 'error'">
          <div class="sdps-notification__text" id="sdpsErrorNotificationText" [innerHTML]="message.detail"></div>
        </sdps-notification>
        <sdps-notification type="warning" id="sdpsWarningNotification" class="toast-confirmation sdps-m-top_none" *ngIf="message.severity === 'warn'">
          <div class="sdps-notification__text" id="sdpsWarningNotificationText" [innerHTML]="message.detail"></div>
        </sdps-notification>
        <sdps-notification type="information" id="sdpsInfoNotification" class="sdps-m-top_none" class="toast-confirmation" *ngIf="message.severity === 'info'">
          <div class="sdps-notification__text" id="sdpsInfoNotificationText" [innerHTML]="message.detail"></div>
        </sdps-notification>
        <sdps-notification type="confirmation" id="sdpsSuccessNotification" class="toast-confirmation sdps-m-top_none" *ngIf="message.severity === 'success'">
          <div class="sdps-notification__text" id="sdpsSuccessNotificationText" [innerHTML]="message.detail"></div>
        </sdps-notification>
        <button type="button" class="p-toast-close-button" aria-label="Close notification" (click)="closeFn($event)">
          <span class="p-toast-close-icon pi pi-times" aria-hidden="true"></span>
        </button>
      </div>
    </ng-template>
  </p-toast>
</div>
